import { createDynamicThunk } from ".";

export const getRoleListThunk = createDynamicThunk({
  typePrefix: "roles/getRoleListThunk",
  useHandleSearch: true,
});

export const getPermissionsThunk = createDynamicThunk({
  typePrefix: "roles/getPermissionsThunk",
  endpoint: "/permissions/findAll",
  method: "POST",
  transformResponse: (response) =>
    response?.response?.map((permission) => ({
      label: permission?.name,
      value: permission?._id,
    })) || [],
});

export const addRoleThunk = createDynamicThunk({
  typePrefix: "roles/addRoleThunk",
  endpoint: "/roles",
  method: "POST",
  refreshList: true,
  listThunk: getRoleListThunk,
});

export const deleteRoleThunk = createDynamicThunk({
  typePrefix: "/deleteRoleThunk",
  endpoint: "/softDeleteMul",
  method: "POST",
  refreshList: true,
  listThunk: getRoleListThunk,
});
